<sm-misc-title-bar
  [headerCustomTemplate]="addButton"
  pageTitle="New promotion"
  [showBackButton]="false"
>
  <ng-template #addButton>
    <div class="d-flex search-field">
      <button
        mat-icon-button
        mat-dialog-close
        class="align-self-end"
        color="accent"
      >
        <mat-icon style="color: #000; position: relative; top: -5px"
          >close</mat-icon
        >
      </button>
    </div>
  </ng-template>
</sm-misc-title-bar>

<!-- <sm-title-bar
  pageTitle="New promotion"
  [backWithParams]="true"
>
</sm-title-bar> -->

<mat-dialog-content>
  <div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Title</mat-label>
      <input [(ngModel)]="promotionData.title" matInput #input />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Description</mat-label>
      <textarea [(ngModel)]="promotionData.body" matInput></textarea>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>External link</mat-label>
      <input [(ngModel)]="promotionData.external_link" matInput #input />
    </mat-form-field>
  </div>
  <!-- <div>
        <mat-form-field appearance="outline">
          <mat-label>Campaign cost</mat-label>
          <input
          smDecimalOnly type="number"
          [(ngModel)]="promotionData.campaign_cost"
            matInput
            #input
          />
          
        </mat-form-field>
      </div> -->
  <div class="chip_memberder">
    <div class="target_headingt">
      <h3>Targets</h3>
    </div>
    <mat-chip-list aria-label="Fish selection">
      <mat-chip
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
      >
        All customers</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '2' }"
        (click)="changeChip('2')"
        >All enrolled members</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '5' }"
        (click)="changeChip('5')"
        >All membership request</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '7' }"
        (click)="changeChip('7')"
        >All service queries</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '3' }"
        (click)="changeChip('3')"
        >Selected customers</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '4' }"
        (click)="changeChip('4')"
        >Selected enrolled members</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '6' }"
        (click)="changeChip('6')"
        >Selected membership request</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '8' }"
        (click)="changeChip('8')"
        >Selected service query</mat-chip
      >
    </mat-chip-list>
  </div>

  <div class="target_hesdingh">
    <p>
      Target selected:
      {{
        promotionData.all_customers == 1
          ? selectedValue == "1"
            ? "All customers"
            : selectedValue == "2"
            ? "All enrolled members"
            : selectedValue == "5"
            ? "All membership request"
            : selectedValue == "7"
            ? "All service queries"
            : ""
          : promotionData.targetArr.length +
            (selectedValue == "3"
              ? " customers"
              : selectedValue == "4"
              ? " enrolled members"
              : selectedValue == "6"
              ? " membership requests"
              : selectedValue == "8"
              ? " service queries"
              : "")
      }}
    </p>
  </div>

  <div>
    <p style="color: rgba(0, 0, 0, 0.6);">Campaign type:</p>
  </div>
  <div
    class="add_crt"
    style="display: flex; gap: 20px; margin-bottom: 20px; margin-top: 15px"
  >
    <div class="try">
      <mat-checkbox
        [(ngModel)]="promotionChecks.whatsapp"
        (change)="updatePromotionType()"
      ></mat-checkbox>
      <label for="testing1" class="check-label">WhatsApp</label>
    </div>
    <div class="try">
      <mat-checkbox
        [(ngModel)]="promotionChecks.email"
        (change)="updatePromotionType()"
      ></mat-checkbox>

      <label for="testing1" class="check-label">E-mail</label>
    </div>
    <div class="try">
      <mat-checkbox
        [(ngModel)]="promotionChecks.sms"
        (change)="updatePromotionType()"
      ></mat-checkbox>

      <label for="testing1" class="check-label">SMS</label>
    </div>
  </div>

  <div class="campaing_datex">
    <div class="row">
      <div class="col-sm-6">
        <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>Campaign start</mat-label>
            <input
              matInput
              [matDatepicker]="fromDatePicker"
              readonly
              [(ngModel)]="promotionData.campaign_start_date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="fromDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>Campaign end</mat-label>
            <input
              matInput
              [matDatepicker]="toDatePicker"
              readonly
              [(ngModel)]="promotionData.campaign_end_date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="toDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div style="display: flex; justify-content: center; align-items: center">
    <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
  </div>
  <div
    class="image-preview"
    *ngIf="assetList.length > 0"
    style="
      position: relative;
      width: fit-content;
      margin-bottom: 20px;
      border: 1px solid lightgray;
      padding: 15px;
    "
  >
    <img
      [src]="assetList[0].url"
      alt=""
      style="width: 200px; height: 170px; object-fit: cover"
    />
    <span
      (click)="removeAsset()"
      style="
        position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        background: #dd2c00;
        border-radius: 50%;
        height: 30px;
        width: 30px;
      "
      ><mat-icon
        style="position: absolute; left: 3px; top: 2px; color: white"
        class="material-icons-outlined"
        >close</mat-icon
      ></span
    >
  </div>
  <div class="upload-group mb-2">
    <label for="formFile" class="form-label">Upload media</label>
    <div class="file-input-wrap">
      <div class="custom-input-label">
        <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
          >backup</mat-icon
        >
        <p>Drop your file(s) here or <span>browse</span></p>
      </div>
      <input
        class="form-control"
        id="formFile"
        accept="image/*"
        type="file"
        multiple
        (change)="onUploadImage($event)"
      />
    </div>
    <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="fill_btrt">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    [disabled]="
      !promotionData.title ||
      !promotionData.body ||
      !promotionData.campaign_start_date ||
      !promotionData.campaign_end_date || promotionData.promotion_type == 0 || 
      ((selectedValue == '3' || selectedValue == '4') &&
        promotionData.targetArr.length == 0)
    "
    (click)="confirm()"
    mat-flat-button
    color="accent"
  >
    Confirm
  </button>
</mat-dialog-actions>
